module.exports = __webpack_public_path__ + "static/media/2_en.a1189ad7.png";